import React, { useEffect, useState } from "react";
import moment from "moment";

import { styled } from "@mui/material/styles";

import FormControl from "@mui/material/FormControl";
import { MenuItem, Select } from "@mui/material";

import { BORDER_GREY, BUTTON_BORDER_RADIUS, WHITE } from "~src/data/constant";

const ModifiedFormControl = styled(FormControl)(() => ({
  margin: "10px",
  padding: "0 8px",
  border: `1px solid ${BORDER_GREY}`,
  borderRadius: BUTTON_BORDER_RADIUS,
  backgroundColor: WHITE,
  minWidth: 120,
}));

const handleChange = (
  handleDateChange,
  calculatedFromDate,
  calculatedToDate
) => {
  handleDateChange({
    target: {
      name: "time-period",
      fromDate: calculatedFromDate,
      toDate: calculatedToDate,
    },
  });
};

export default function CustomDatesContainer({
  setDateFilterUsed,
  isDateFilterUsed,
  setCustomPeriod,
  handleDateChange,
  setDisplayDates,
}) {
  const [dateDropdown, setDateDropdown] = useState("last-calender-year");

  const handleDateDropDownChange = (event) => {
    setDisplayDates(() => ({
      startDate: null,
      endDate: null,
    }));
    const currentDate = new Date();

    const fieldValue = event.target.value;

    setCustomPeriod(fieldValue);

    if (fieldValue === "this-month") {
      const calculatedFromDate = moment(currentDate)
        .startOf("month")
        .format("YYYY-MM-DD");
      const calculatedToDate = moment(currentDate).format("YYYY-MM-DD");

      handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
    } else if (fieldValue === "last-month") {
      const calculatedFromDate = moment(currentDate)
        .subtract(1, "months")
        .startOf("month")
        .format("YYYY-MM-DD");

      const calculatedToDate = moment(currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD");

      handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
    } else if (fieldValue === "last-3-months") {
      const calculatedFromDate = moment(currentDate)
        .subtract(3, "months")
        .startOf("month")
        .format("YYYY-MM-DD");
      const calculatedToDate = moment(currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD");
      handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
    } else if (fieldValue === "year-to-last-month") {
      const calculatedFromDate = moment(currentDate)
        .subtract(0, "year")
        .startOf("year")
        .format("YYYY-MM-DD");
      const calculatedToDate = moment(currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD");
      handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
    } else if (fieldValue === "last-12-months") {
      const calculatedFromDate = moment(currentDate)
        .subtract(12, "months")
        .startOf("month")
        .format("YYYY-MM-DD");
      const calculatedToDate = moment(currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD");

      handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
    } else if (fieldValue === "last-calender-year") {
      const calculatedFromDate = moment(currentDate)
        .subtract(1, "year")
        .startOf("year")
        .format("YYYY-MM-DD");
      const calculatedToDate = moment(currentDate)
        .subtract(1, "year")
        .endOf("year")
        .format("YYYY-MM-DD");

      handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
    }
    setDateDropdown(fieldValue);
  };

  useEffect(() => {
    if (dateDropdown !== "custom-date") {
      setDateFilterUsed(false);
      handleDateDropDownChange({ target: { value: "custom-date" } });
    }
  }, [isDateFilterUsed]);

  return (
    <ModifiedFormControl
      variant="standard"
      size="small"
      sx={{
        display: "flex",
        justifyContent: "center",
        m: 1,
        width: 100,
        height: "90%",
      }}
    >
      <Select
        id="dateDropdown"
        name="dateDropdown"
        value={dateDropdown}
        onChange={handleDateDropDownChange}
        disableUnderline
      >
        <MenuItem disabled default value="custom-date">
          Custom Date
        </MenuItem>
        <MenuItem value="this-month">This Month</MenuItem>
        <MenuItem value="last-month">Last Month</MenuItem>
        <MenuItem value="last-3-months">Last 3 Months</MenuItem>
        <MenuItem value="year-to-last-month">Year to Last Month</MenuItem>
        <MenuItem value="last-12-months">Last 12 Months</MenuItem>
        <MenuItem value="last-calender-year">Last Calender Year</MenuItem>
      </Select>
    </ModifiedFormControl>
  );
}





//by default 12 months data here
// import React, { useEffect, useState } from "react";
// import moment from "moment";

// import { styled } from "@mui/material/styles";

// import FormControl from "@mui/material/FormControl";
// import { MenuItem, Select } from "@mui/material";

// import { BORDER_GREY, BUTTON_BORDER_RADIUS, WHITE } from "~src/data/constant";

// const ModifiedFormControl = styled(FormControl)(() => ({
//   margin: "10px",
//   padding: "0 8px",
//   border: `1px solid ${BORDER_GREY}`,
//   borderRadius: BUTTON_BORDER_RADIUS,
//   backgroundColor: WHITE,
//   minWidth: 120,
// }));

// const handleChange = (
//   handleDateChange,
//   calculatedFromDate,
//   calculatedToDate
// ) => {
//   handleDateChange({
//     target: {
//       name: "time-period",
//       fromDate: calculatedFromDate,
//       toDate: calculatedToDate,
//     },
//   });
// };

// export default function CustomDatesContainer({
//   setDateFilterUsed,
//   isDateFilterUsed,
//   setCustomPeriod,
//   handleDateChange,
//   setDisplayDates,
// }) {
//   const [dateDropdown, setDateDropdown] = useState("last-12-months");

//   const handleDateDropDownChange = (event) => {
//     setDisplayDates(() => ({
//       startDate: null,
//       endDate: null,
//     }));
//     const currentDate = new Date();

//     const fieldValue = event.target.value;

//     setCustomPeriod(fieldValue);

//     if (fieldValue === "this-month") {
//       const calculatedFromDate = moment(currentDate)
//         .startOf("month")
//         .format("YYYY-MM-DD");
//       const calculatedToDate = moment(currentDate).format("YYYY-MM-DD");

//       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
//     } else if (fieldValue === "last-month") {
//       const calculatedFromDate = moment(currentDate)
//         .subtract(1, "months")
//         .startOf("month")
//         .format("YYYY-MM-DD");

//       const calculatedToDate = moment(currentDate)
//         .subtract(1, "months")
//         .endOf("month")
//         .format("YYYY-MM-DD");

//       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
//     } else if (fieldValue === "last-3-months") {
//       const calculatedFromDate = moment(currentDate)
//         .subtract(3, "months")
//         .startOf("month")
//         .format("YYYY-MM-DD");
//       const calculatedToDate = moment(currentDate)
//         .subtract(1, "months")
//         .endOf("month")
//         .format("YYYY-MM-DD");
//       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
//     } else if (fieldValue === "year-to-last-month") {
//       const calculatedFromDate = moment(currentDate)
//         .subtract(0, "year")
//         .startOf("year")
//         .format("YYYY-MM-DD");
//       const calculatedToDate = moment(currentDate)
//         .subtract(1, "months")
//         .endOf("month")
//         .format("YYYY-MM-DD");
//       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
//     } else if (fieldValue === "last-12-months") {
//       const calculatedFromDate = moment(currentDate)
//         .subtract(12, "months")
//         .startOf("month")
//         .format("YYYY-MM-DD");
//       const calculatedToDate = moment(currentDate)
//         .subtract(1, "months")
//         .endOf("month")
//         .format("YYYY-MM-DD");

//       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
//     } else if (fieldValue === "last-calender-year") {
//       const calculatedFromDate = moment(currentDate)
//         .subtract(1, "year")
//         .startOf("year")
//         .format("YYYY-MM-DD");
//       const calculatedToDate = moment(currentDate)
//         .subtract(1, "year")
//         .endOf("year")
//         .format("YYYY-MM-DD");

//       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
//     }
//     setDateDropdown(fieldValue);
//   };

//   useEffect(() => {
//     if (dateDropdown !== "custom-date") {
//       setDateFilterUsed(false);
//       handleDateDropDownChange({ target: { value: "custom-date" } });
//     }
//   }, [isDateFilterUsed]);

//   // Set the default selection to "last-12-months" on initial load
//   useEffect(() => {
//     const currentDate = new Date();
//     const calculatedFromDate = moment(currentDate)
//       .subtract(12, "months")
//       .startOf("month")
//       .format("YYYY-MM-DD");
//     const calculatedToDate = moment(currentDate)
//       .subtract(1, "months")
//       .endOf("month")
//       .format("YYYY-MM-DD");

//     handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
//   }, []);

//   return (
//     <ModifiedFormControl
//       variant="standard"
//       size="small"
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         m: 1,
//         width: 100,
//         height: "90%",
//       }}
//     >
//       <Select
//         id="dateDropdown"
//         name="dateDropdown"
//         value={dateDropdown}
//         onChange={handleDateDropDownChange}
//         disableUnderline
//       >
//         <MenuItem disabled default value="custom-date">
//           Custom Date
//         </MenuItem>
//         <MenuItem value="this-month">This Month</MenuItem>
//         <MenuItem value="last-month">Last Month</MenuItem>
//         <MenuItem value="last-3-months">Last 3 Months</MenuItem>
//         <MenuItem value="year-to-last-month">Year to Last Month</MenuItem>
//         <MenuItem value="last-12-months">Last 12 Months</MenuItem>
//         <MenuItem value="last-calender-year">Last Calender Year</MenuItem>
//       </Select>
//     </ModifiedFormControl>
//   );
// }